<template>
  <tr class="clickable" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding"></td>
    <td :data-th="'Popis' | translate">
      {{ entity.description }}
    </td>
    <td :data-th="'Celkový počet běhů' | translate">
      {{ entity.run_count }}
    </td>
    <td :data-th="'Poslední spuštění' | translate"  v-html="$_date_formatFull(entity.last_run_date)"></td>
    <td :data-th="'Vytvořeno' | translate"  v-html="$_date_formatFull(entity.date_created)"></td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"

export default {
  name: "CodecRow",
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  data() {
    return {
      moduleName: 'customExports',
      detailPageRouteName: 'customExportDetail',
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/customExports/CustomExportRow.vue